import { ISchema } from '../../@types'
import { mergeDeep } from '@/helpers/utils'
import { IdentsOverrideId } from '@/helpers/identsOverrideIds'

// High CR regular (base discounted) — shown to `same`/`premium` ML segments
import high_1w_reg from '@/data/products/subscription/prd_qsRUc8c8LpKl'
import high_4w_reg from '@/data/products/subscription/prd_K1E5wBJ4VAmI'
import high_12w_reg from '@/data/products/subscription/prd_ZqA4y0025e6j'

// Low CR regular — Low CR `discounted` AND High CR `fallback` (PRD: High CR fallback == Low CR intro)
import low_1w_reg from '@/data/products/subscription/prd_Ehunvmipw4zl'
import low_4w_reg from '@/data/products/subscription/prd_Q1aRLGmyYjfz'
import low_12w_reg from '@/data/products/subscription/prd_w9Xrf1I9oxmi'

// Low CR fallback
import low_1w_fb from '@/data/products/subscription/prd_GYyamkZWiQB4'
import low_4w_fb from '@/data/products/subscription/prd_eRryzCAUP6HR'
import low_12w_fb from '@/data/products/subscription/prd_b9tkF471qv36'

// female / female-water-fasting base paywall has no countdown-original (original = null), fallback filled.
// Base idents = High CR (fallback drops to Low CR intro); ML discount segment swaps to Low CR via identsOverride.
export default (schema: ISchema): ISchema =>
	mergeDeep(
		{ ...schema },
		{
			config: {
				removeDiscountAfterCountdown: false,
				products: [
					{
						idents: {
							discounted: high_1w_reg.ident,
							fallback: low_1w_reg.ident,
						},
						identsOverride: [
							{
								id: IdentsOverrideId.ML_PRICE_DISCOUNT,
								discounted: low_1w_reg.ident,
								fallback: low_1w_fb.ident,
							},
						],
					},
					{
						idents: {
							discounted: high_4w_reg.ident,
							fallback: low_4w_reg.ident,
						},
						identsOverride: [
							{
								id: IdentsOverrideId.ML_PRICE_DISCOUNT,
								discounted: low_4w_reg.ident,
								fallback: low_4w_fb.ident,
							},
						],
						default: true,
					},
					{
						idents: {
							discounted: high_12w_reg.ident,
							fallback: low_12w_reg.ident,
						},
						identsOverride: [
							{
								id: IdentsOverrideId.ML_PRICE_DISCOUNT,
								discounted: low_12w_reg.ident,
								fallback: low_12w_fb.ident,
							},
						],
					},
				],
			},
		},
	)
